import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import getUpdatedVideo from "./updateLikeUnlikeAPI";

//initial state
const initialState = {
    updatedVideo: {},
    isError: false,
    error: "",
};

//async thunk action
export const updateLikeUnlike = createAsyncThunk(
    "video/updateLikeUnlike",
    async ({ videoId, likes, unlikes }) => {
        const updatedVideo = await getUpdatedVideo(videoId, likes, unlikes);
        return updatedVideo;
    }
);

// video slice
const updateLikeUnlikeSlice = createSlice({
    name: "updateLikeUnlike",
    initialState,
    reducers: {
        removeVideo: (state) => {
            state.updatedVideo = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateLikeUnlike.fulfilled, (state, action) => {
                state.updatedVideo = action.payload;
            })
            .addCase(updateLikeUnlike.rejected, (state, action) => {
                state.isError = true;
                state.error = action.error.message;
            });
    },
});

export default updateLikeUnlikeSlice.reducer;
export const { removeVideo } = updateLikeUnlikeSlice.actions;
